module.exports = __webpack_public_path__ + "static/media/cartoon_pm_jl_hui.e6f39f84.png";